import { Writer } from 'ckeditor5';
import {
    $applyNodeReplacement,
    DOMConversionMap,
    DOMConversionOutput,
    EditorConfig,
    ElementFormatType,
    NodeKey,
    ParagraphNode,
    SerializedParagraphNode,
    setNodeIndentFromDOM,
    Spread,
} from 'lexical';

export type SerializedCustomParagraphNode = Spread<
  {
    lineHeight: string | undefined
  },
  SerializedParagraphNode
>;

export class CustomParagraphNode extends ParagraphNode {
    __lineHeight: string | undefined;
    constructor(lineHeight?: string, key?: NodeKey) {
        super(key);
        this.__lineHeight = lineHeight;
    }
    static getType() {
        return 'custom-paragraph';
    }
    static clone(node: CustomParagraphNode): CustomParagraphNode {
        return new CustomParagraphNode(node.__lineHeight, node.__key);
    }

    static importDOM(): DOMConversionMap | null {
        return {
            p: (node: Node) => ({
                conversion: $convertParagraphElement,
                priority: 0,
            }),
        };
    }

    updateDOM(prevNode: CustomParagraphNode, dom: HTMLElement, config: EditorConfig): boolean {
        return prevNode.__lineHeight !== this.__lineHeight;
    }

    static importJSON(json: SerializedCustomParagraphNode): CustomParagraphNode {
        return $createCustomParagraphNode().updateFromJSON(json);
    }
    createDOM(config: EditorConfig) {
        const el = super.createDOM(config);
        if (this.__lineHeight) {
            el.style.lineHeight = this.__lineHeight;
        }
        return el;
    }

    exportJSON(): SerializedCustomParagraphNode {
        return {
            ...super.exportJSON(),
            lineHeight: this.__lineHeight
        };
    }

    setLineHeight(lineHeight: string) {
        let writable = this.getWritable();
        writable.__lineHeight = lineHeight;
    }
}

function $convertParagraphElement(element: HTMLElement): DOMConversionOutput {
    let node = $createCustomParagraphNode();
    if (element.style) {
        node.setFormat(element.style.textAlign as ElementFormatType);
        setNodeIndentFromDOM(element, node);
        if (element.style.lineHeight) {
            node.setLineHeight(element.style.lineHeight);
        }
    }
    return { node };
}

export function $createCustomParagraphNode() {
    return $applyNodeReplacement(new CustomParagraphNode());
}